<template>
  <v-container>
    <form color="transparent" width="100%">
      <div>
        <v-row>
          <v-col>
            <h2>Edit Device</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="device.deviceId"
              label="Name"
              filled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="device.location"
              label="Location"
              filled
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="device.setTorque"
              label="Set Torque (Nm)"
              filled
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <hr class="horizontal black my-1 mt-3 mb-5" />
        <v-row>
          <v-col>
            <h5 class="font-weight-light">Thresholds</h5>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="device.thresholds.green"
              label="Secure Threshold"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="device.thresholds.yellow"
              label="Warning Threshold"
              filled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="device.thresholds.red"
              label="Warning Threshold"
              filled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-btn outlined class="" width="100%" @click="updateDevice"
          >Update Device</v-btn
        >
        <v-row>
          <v-col> </v-col>
        </v-row>
      </div>
    </form>
  </v-container>
</template>
<script>
export default {
  name: "EditDevice",
  props: {
    hideForm: Function,
  },
  data() {
    return {
      device: {
        deviceId: "ximu3-001",
        key: "ximu3-001",
        lastUpdated: "2025-04-08T03:40:36.334Z",
        location: "Pumping Station, Sector 5",
        setTorque: 150,
        thresholds: {
          green: 5,
          red: 45,
          yellow: 15,
        },
      },
    };
  },
  methods: {
    updateDevice() {
      this.$store.dispatch("updateDevice", this.device);
      this.hideForm();
    },
  },
  async created() {
    this.device = await this.$store.state.sensor;
  },
};
</script>
